"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SagaYieldType = void 0;
exports.createWatcherSaga = createWatcherSaga;
const effects_1 = require("redux-saga/effects");
var SagaYieldType;
(function (SagaYieldType) {
    SagaYieldType[SagaYieldType["Every"] = 0] = "Every";
    SagaYieldType[SagaYieldType["Latest"] = 1] = "Latest";
    SagaYieldType[SagaYieldType["Leading"] = 2] = "Leading";
})(SagaYieldType || (exports.SagaYieldType = SagaYieldType = {}));
function createWatcherSaga(steps) {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return function* watchSagas() {
        for (let i = 0; i < steps.length; i += 1) {
            const step = steps[i];
            switch (step.type) {
                case SagaYieldType.Every:
                    yield (0, effects_1.takeEvery)(step.action, step.actionHandler);
                    break;
                case SagaYieldType.Latest:
                    yield (0, effects_1.takeLatest)(step.action, step.actionHandler);
                    break;
                case SagaYieldType.Leading:
                    yield (0, effects_1.takeLeading)(step.action, step.actionHandler);
                    break;
                default:
                    break;
            }
        }
    };
}
//# sourceMappingURL=createWatcherSaga.js.map